import { PropTypes, React } from 'imports';
import Spinner from 'components/common/Spinner/Spinner';
import { deepEqual, omit } from 'utils';
import load from 'little-loader';
import './ComponentLoader.less';

// TODO build automatically based on folder structure
// TODO try creating separate bundles instead of using require.ensure:
//      1. it's easy to do based on folders
//      2. it seems that tree shaking operates on the whole bundle
//          for example every export of common/index is used across the application, but most of chunks use 2-3 of them
//          still webpack can not drop any exports as unused and includes full set of common components to every chunk using any of them
//          and then CommonsChunkPlugin extracts them to a chunk loading right after startup
//          but probably if chunks were separate bundles webpack would include only actually used common components into each of them
//          and CommonsChunkPlugin wouldn't move rarely used components to common chunk
//          reducing load time
// alternative is to specify actual paths to common components instead of index and short paths, but it's so much more to type...
// TODO use explicit named exports, reexports in index and imports for actions, at least it will allow tree shaking
// and combined with one of approaches above it might move them from main chunk to more specific ones
const
    g = (context, component) => context(context.keys().find(key => key.includes(`${component}/${component}`)) || `./${component}/${component}`),
    SCOPE_LOADERS = {
        'alerts': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/alerts\//), p)), 'alerts'),
        'analyses': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/analyses\//), p)), 'analyses'),
        'bing-search': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/bing-search\//), p)), 'bing-search'),
        'business-review': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/business-review\//), p)), 'business-review'),
        'calendar': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/calendar\//), p)), 'calendar'),
        'common': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/common\//), p)), 'common'),
        'company': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/company\//), p)), 'company'),
        'corporate-structure': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/corporate-structure\//), p)), 'corporate-structure'),
        'dashboard': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/dashboard\//), p)), 'dashboard'),
        'demo': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/demo\//), p)), 'demo'),
        'dialog': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/dialog\//), p)), 'dialog'),
        'financial-management': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/financial-management\//), p)), 'financial-management'),
        'foresights': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/foresights\//), p)), 'foresights'),
        'insight': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/insight\//), p)), 'insight'),
        'integration': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/integration\//), p)), 'integration'),
        'layout': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/layout\//), p)), 'layout'),
        'market': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/market\//), p)), 'market'),
        'market-watch': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/market-watch\//), p)), 'market-watch'),
        'meeting': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/meeting\//), p)), 'meeting'),
        'newsfeed': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/newsfeed\//), p)), 'newsfeed'),
        'organization-structure': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/organization-structure\//), p)), 'organization-structure'),
        'partner-management': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/partner-management\//), p)), 'partner-management'),
        'performance-indicator': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/performance-indicator\//), p)), 'performance-indicator'),
        'public': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/public\//), p)), 'public'),
        'routing': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/routing/), p)), 'routing'),
        'stakeholders': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/stakeholders\//), p)), 'stakeholders'),
        'strategy': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/strategy\//), p)), 'strategy'),
        'strategy-sprint': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/strategy-sprint\//), p)), 'strategy-sprint'),
        'subscription': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/subscription\//), p)), 'subscription'),
        'swot': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/swot\//), p)), 'swot'),
        'topics': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/topics\//), p)), 'topics'),
        'trend': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/trend\//), p)), 'trend'),
        'user-list': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/user-list\//), p)), 'user-list'),
        'users': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/users\//), p)), 'users'),
        'welcome-guide': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/welcome-guide\//), p)), 'welcome-guide'),
        'workshop': c => require.ensure([], () => c(p => g(require.context('../../../', true, /(typed\/)?components\/workshop\//), p)), 'workshop')
    },

    loadedDLLs = {},
    loadedScopes = {};

export default class ComponentLoader extends React.Component {
    // a shitty way to get static fields of a loaded component without referencing it with import
    // TODO a better way?
    static static(extractor) {
        return { extractor };
    }

    static get propTypes() {
        return {
            scope: PropTypes.oneOf(Object.keys(SCOPE_LOADERS)).isRequired,
            component: PropTypes.string.isRequired,
            dlls: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(DLL_PATHS))),
            spinnerVisible: PropTypes.bool,
            componentVisible: PropTypes.bool,
            onPending: PropTypes.func,
            onReady: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            dlls: [],
            spinnerVisible: true,
            componentVisible: true
        };

    }

    static get NON_COMPONENT_PROPS() { return [...Object.keys(ComponentLoader.propTypes), 'children']; }

    state = {
        component: null,
        componentProps: {}
    };

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        let { state } = this;
        if (this.props === nextProps || this.props.scope !== nextProps.scope || this.props.component !== nextProps.component || !deepEqual(this.props.dlls, nextProps.dlls)) {
            this.setState(state = {
                component: null,
                componentProps: {}
            });

            if (nextProps.onPending) {
                nextProps.onPending(this);
            }

            nextProps.dlls.forEach((name) => {
                if (DEBUG && !DLL_PATHS[name]) {
                    throw Error(`Can not find DLL "${name}"`);
                }
                if (!loadedDLLs[name]) {
                    load(DLL_PATHS[name], () => this._onScriptLoaded(loadedDLLs[name] = true));
                }
                else {
                    this._onScriptLoaded();
                }
            });

            if (DEBUG && !SCOPE_LOADERS[nextProps.scope]) {
                throw new Error(`Can not find scope ${nextProps.scope}.`);
            }

            SCOPE_LOADERS[nextProps.scope](l => this._onScriptLoaded(loadedScopes[nextProps.scope] = l));
        }

        this._mergeComponentProps(nextProps, state);
    }

    componentWillUnmount() {
        this._isComponentUnmounting = true;
    }

    _isComponentUnmounting = false;

    _mergeComponentProps(nextProps, state = this.state) {
        for (var i in nextProps) {
            if (nextProps.hasOwnProperty(i) && !ComponentLoader.NON_COMPONENT_PROPS.includes(i) && state.componentProps[i] !== nextProps[i]) {
                return this.setState({ componentProps: omit(nextProps, ComponentLoader.NON_COMPONENT_PROPS) });
            }
        }
        for (var i in state.componentProps) {
            if (state.componentProps.hasOwnProperty(i) && !nextProps.hasOwnProperty(i)) {
                return this.setState({ componentProps: omit(nextProps, ComponentLoader.NON_COMPONENT_PROPS) });
            }
        }
    }

    _onScriptLoaded() {
        if (!this.state.component && this.props.dlls.every(l => loadedDLLs[l]) && loadedScopes[this.props.scope]) {
            if (!this._isComponentUnmounting) {
                this.setState({ component: loadedScopes[this.props.scope](`${this.props.component}`).default });
            }

            if (this.props.onReady) {
                this.props.onReady(this);
            }
        }
    }

    render() {
        let { componentProps } = this.state;
        if (this.state.component) {
            for (const i in componentProps) {
                if (componentProps[i] && componentProps[i].extractor) {
                    if (componentProps === this.state.componentProps) {
                        componentProps = { ...componentProps };
                    }
                    componentProps[i] = componentProps[i].extractor(this.state.component);
                }
            }
        }

        return (
            <div className="component-loader" >
                {
                    this.state.component ?
                        this.props.componentVisible ?
                            <this.state.component {...componentProps} >{this.props.children}</this.state.component> :
                            null :
                        this.props.spinnerVisible ?
                            <Spinner /> :
                            null
                }
            </div>
        );
    }
}
